import { FaHome } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import version from "./../../../package.json";
import AdmissionForm from "./AdmissionForm";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import { useEffect } from "react";
import courses from "./courses";

const AdmissionBaseLayout = () => {
  const dispatch = useDispatch();
  const { courseName, courseYear } = useParams();
  const date = new Date().toISOString().split("T")[0].split("-")[0];
  const navigate = useNavigate();
  const studentInformation = useSelector((state) => state.auth.studentData);
  const isApplicationFilled =
    studentInformation?.admissions?.enrollment_year === date ? true : false;
  useEffect(() => {
    authService.getUser(dispatch);
  }, []);
  if (isApplicationFilled) {
    return navigate("/student/addmission");
  }

  const CourseData = courses.find((c) => c.code === courseName.toUpperCase());

  const course_year =
    courseYear === "part-1"
      ? "Part-1"
      : courseYear === "part-2"
        ? "Part-2"
        : courseYear === "part-3" && "Part-3";

  return (
    <div className="admission-container">
      <ul className="application_info">
        <li>
          {/* <a style={{color:'inherit'}} href="/student-dashboard">
              <FaHome />
            </a> */}
        </li>
        <li
          onClick={() =>
            console.log(studentInformation, CourseData, course_year)
          }
        >
          2026-2027 - Application for {CourseData?.name}({CourseData?.code})-
          {course_year}
        </li>
        <li>v-{version.version}</li>
      </ul>

      <div className="form-container">
        <AdmissionForm
          course_year={
            courseYear === "part-1"
              ? 1
              : courseYear === "part-2"
                ? 2
                : courseYear === "part-3" && 3
          }
          course={CourseData}
          studentInformation={studentInformation}
        />
      </div>
    </div>
  );
};

export default AdmissionBaseLayout;
